export default "__VITE_ASSET__Bxr3JbLA__"